/**
 * Theme-mode preference (light/dark) — global client state, so Zustand (R-18.106).
 *
 * Persisted to localStorage: this is a NON-SENSITIVE UI preference, not an auth token.
 * R-18.198/R-18.199 prohibit storing AUTH TOKENS in localStorage — a colour-scheme flag
 * is explicitly fine and never round-trips a credential.
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import type { ThemeMode } from '@/shared/theme/tokens';

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'light',
      setMode: (mode) => set({ mode }),
      toggle: () => set((s) => ({ mode: s.mode === 'dark' ? 'light' : 'dark' })),
    }),
    {
      name: 'stuttgart-crm.theme',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ mode: s.mode }),
    },
  ),
);
